"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentEntityToJSON = exports.ParentEntityFromJSONTyped = exports.ParentEntityFromJSON = exports.instanceOfParentEntity = void 0;
var runtime_1 = require("../runtime");
var ReportEntityStatus_1 = require("./ReportEntityStatus");
/**
 * Check if a given object implements the ParentEntity interface.
 */
function instanceOfParentEntity(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfParentEntity = instanceOfParentEntity;
function ParentEntityFromJSON(json) {
    return ParentEntityFromJSONTyped(json, false);
}
exports.ParentEntityFromJSON = ParentEntityFromJSON;
function ParentEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, ReportEntityStatus_1.ReportEntityStatusFromJSON)(json['status']),
    };
}
exports.ParentEntityFromJSONTyped = ParentEntityFromJSONTyped;
function ParentEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'status': (0, ReportEntityStatus_1.ReportEntityStatusToJSON)(value.status),
    };
}
exports.ParentEntityToJSON = ParentEntityToJSON;
